import { Injector, Scope } from 'typed-inject';

import { authorizeClient } from '@/api/http-client';
import { JwtApiFactory } from '@eloomi/eloomi-users-persona-client/1.0';
import { PlatformResolutionService } from '@/common/services';
import type { BaseInjectionContext } from '@/di/base-injector';

import {
    JWTAuthenticationService,
    VueRouterRedirectionService,
    JWTLoginSessionManager,
    ActivateUserService,
    ForgotPasswordService,
    ResetPasswordService,
} from './services';
import { ResetSessionDataService } from './services/reset-session-data';

import { AuthenticationServiceTokens as Tokens } from './di-tokens';
import { AuthFlowStoreServiceFactory } from './store';
import { LogoutUseCase } from './use-cases';

export function provideAuthenticationServices<TContext extends BaseInjectionContext>(baseInjector: Injector<TContext>) {
    return (
        baseInjector
            .provideClass(Tokens.PlatformResolutionService, PlatformResolutionService)
            .provideClass(Tokens.AuthenticationService, JWTAuthenticationService)
            .provideClass(Tokens.SessionManager, JWTLoginSessionManager)
            .provideClass(Tokens.ResetSessionDataService, ResetSessionDataService)
            .provideClass(Tokens.RedirectService, VueRouterRedirectionService)
            .provideFactory(Tokens.SessionApiClient, () => authorizeClient(JwtApiFactory))
            .provideClass(Tokens.ActivateUserService, ActivateUserService)
            .provideClass(Tokens.ForgotPasswordService, ForgotPasswordService)
            .provideClass(Tokens.ResetPasswordService, ResetPasswordService)
            .provideClass(Tokens.LogoutUseCase, LogoutUseCase)

            // Since Auth flow store is a dynamic vuex module it make sense to make scope to be not Singleton
            .provideFactory(Tokens.AuthFlowStoreService, AuthFlowStoreServiceFactory, Scope.Transient)
    );
}

export { Tokens as AuthenticationServiceTokens };
